import { render, staticRenderFns } from "./VTopNav.vue?vue&type=template&id=46fb8a86&scoped=true&"
import script from "./VTopNav.vue?vue&type=script&lang=ts&"
export * from "./VTopNav.vue?vue&type=script&lang=ts&"
import style0 from "./VTopNav.vue?vue&type=style&index=0&id=46fb8a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb8a86",
  null
  
)

export default component.exports